// @flow

import Breakpoints from './Breakpoints';
import Colors from './Colors';
import Fonts from './Fonts';
import WebMetrics from './WebMetrics';
import WebStyles from './WebStyles';
import { mq as Mq } from './Mq';

export { Breakpoints, Colors, Fonts, WebStyles, WebMetrics, Mq };

type ThemeValuesObj = {
    [string]: {
        [string]: string | number
    }
};

export type Theme = {
    Fonts: ThemeValuesObj,
    WebMetrics: ThemeValuesObj,
    Colors: {
        [string]: string | number
    },
    Breakpoints: ThemeValuesObj,
    WebStyles: ThemeValuesObj
};
